import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolListComponent } from 'src/app/component/tools/tool-list/tool-list.component';
import { DynamicComponentDirective } from 'src/app/directive/dynamicComponent/dynamic-component.directive';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { PermissionsService } from 'src/app/service/auth/permissions.service';

@Component({
  selector: 'app-configuration-settings-table',
  templateUrl: './configuration-settings-table.component.html',
  styleUrls: ['./configuration-settings-table.component.scss'],
})
export class ConfigurationSettingsTableComponent implements OnInit {
  @Input() headers: any; // column headers for table
  @Input() rows: any; // row data to display in table
  @Input() totalItems: any;
  @Input() sortData: string; // data indicating column
  @Input() selected?: Array<any>;
  @Input() meta: any;
  @Input() source: string;
  @Output() action = new EventEmitter<any>();
  @Output() selectedChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
  @Output() selectedAdd = new EventEmitter<any>();
  @Output() selectedRemove = new EventEmitter<any>();
  @Output() selectedAll = new EventEmitter<any>();
  @Output() refreshSelectAll = new EventEmitter<any>();
  @Output() removeAll = new EventEmitter<any>();

  subscription: Subscription;
  deselectAll: Boolean;

  @ViewChild(DynamicComponentDirective)
  dynamicComponent: DynamicComponentDirective;

  sort: any = { name: '', direction: '' };
  sortDirection: any = { asc: 'desc', desc: 'asc' }; // used as a toggle to switch between asc and desc order
  defaultDirection: string = 'asc';

  constructor(
    private toolList: ToolListComponent,
    private loaderService: LoaderService,
    private permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    const [field, direction] = this.sortData?.split(',') || ['', ''];
    this.sort.name = field;
    this.sort.direction = direction;
    this.toolList.refreshAll.subscribe(res => {
      if (!Object.keys(res).length || !res.data) {
        return;
      }
      if (res.data.length === this.totalItems) {
        if (!this.deselectAll) {
          this.selected = [...res.data.map(row => row.id)];
          this.selectedAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        } else {
          this.selected = [];
          this.removeAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        }
        if (res.data.length > 50) this.refreshSelectAll.emit(50);
        this.loaderService.hideLoader();
      }
    });
  }

  triggerAction(action: string, payload) {
    if (action === 'sort') {
      if (this.sort.name === payload) {
        this.sort.direction = this.sortDirection[this.sort.direction] || this.defaultDirection;
      } else {
        this.sort.name = payload;
        this.sort.direction = this.defaultDirection;
      }
      payload = `${this.sort.name},${this.sort.direction}`;
    }
    const actionData = { action, payload, source: this.source };
    this.action.emit(actionData);
  }

  printRowData(property, row, defaultValue = ''): string {
    if (typeof property === 'function') {
      return property(row);
    }
    return row[property] ? row[property] : defaultValue;
  }

  handleSelectAll(event: any) {
    this.loaderService.displayLoader();
    if (event.target.checked) {
      this.deselectAll = false;
      this.refreshSelectAll.emit();
    } else {
      this.deselectAll = true;
      this.removeAll.emit();
      this.loaderService.hideLoader();
    }
  }

  handleCheckbox(event): void {
    if (!event.target.checked) {
      // remove value, if  unchecked
      this.selected.splice(this.selected.indexOf(+event.target.value), 1);
      this.selectedChange.emit(this.selected);
      this.selectedRemove.emit(+event.target.value);
      return;
    }

    // push new value onto list, if checked
    this.selected.push(+event.target.value);
    this.selectedChange.emit(this.selected);
    this.selectedAdd.emit(+event.target.value);
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_pointe_configuration: 'job_pointe_configuration',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }
}
